import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field } from 'redux-form';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class StandardDropdown extends Component {

  render () {

    const {
      name,
      form,
      searchFn,
      multiple,
      dropdownType,
      type,
      isFix,
      preload = true,
    } = this.props;

    return (
      <Field
        {...this.props} 
        name={name}
        formId={form}
        dropdownType={dropdownType}
        type={type}
        searchFn={searchFn}
        component={ multiple ? renderSearchMultipleDropdown : renderSearchDropDown }
        preload={preload}
        isFix={isFix}
      />
    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(StandardDropdown);